import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MainComponent } from "./main.component";
import { AuthGuardMain } from "../auth/auth-guard.service";
import { PermissionGuard } from "../guards/permisson.guard";

const routes: Routes = [
  {
    path: "main",
    component: MainComponent,
    canActivate: [AuthGuardMain],
    children: [
      { path: "", redirectTo: "/main/dashboard", pathMatch: "full" },
      {
        canActivate: [AuthGuardMain],
        path: "dashboard",
        loadChildren: () =>
          import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
      {
        path: "analytic",
        loadChildren: () =>
          import("./analytic/analytic.module").then((m) => m.AnalyticModule),
      },
      {
        
        path: "influencers-management",
        canActivate: [PermissionGuard],
        data: { access: "influencer" },
        loadChildren: () =>
          import("../main/influencer-management/influencer-management.module").then(
            (m) => m.InfluencerManagementModule
          ),
      },
      {
        path: "password",
        loadChildren: () =>
          import("../main/password/password.module").then(
            (m) => m.PasswordModule
          ),
      },
      {
        path: "user-management",
        canActivate: [PermissionGuard],
        data: { access: "users" },
        loadChildren: () =>
          import("../main/user-management/user-management.module").then(
            (m) => m.UserManagementModule
          ),
      },
      {
        path: "roles",
        canActivate: [PermissionGuard],
        data: { access: "roles" },
        loadChildren: () =>
          import("../main/roles/roles.module").then((m) => m.RolesModule),
      },
      {
        path: "operator",
        canActivate: [PermissionGuard],
        data: { access: "operators" },
        loadChildren: () =>
          import("../main/operator/operator.module").then(
            (m) => m.OperatorModule
          ),
      },
      {
        path: "vehicle",
        canActivate: [PermissionGuard],
        data: { access: "vehicles" },
        loadChildren: () =>
          import("../main/vehicle/vehicle.module").then((m) => m.VehicleModule),
      },
      {
        path: "passenger",
        canActivate: [PermissionGuard],
        data: { access: "passengers" },
        loadChildren: () =>
          import("../main/passenger/passenger.module").then(
            (m) => m.PassengerModule
          ),
      },
      {
        path: "audit",
        canActivate: [PermissionGuard],
        data: { access: "audit" },
        loadChildren: () =>
          import("../main/audit-management/audit-management.module").then(
            (m) => m.AuditManagementModule
          ),
      },
      {
        path: "city",
        canActivate: [PermissionGuard],
        data: { access: "city" },
        loadChildren: () =>
          import("../main/category-management/category-management.module").then(
            (m) => m.CategoryManagementModule
          ),
      },
      {
        path: "payment-management",
        canActivate: [PermissionGuard],
        data: { access: "invoices" },
        loadChildren: () =>
          import("../main/payment-management/payment-management.module").then(
            (m) => m.PaymentManagementModule
          ),
      },
      
      {
        path: "order",
        canActivate: [PermissionGuard],
        data: { access: "order" },
        loadChildren: () =>
          import("../main/order-management/order-management.module").then(
            (m) => m.OrderManagementModule
          ),
      },
      {
        path: "fare",
        canActivate: [PermissionGuard],
        data: { access: "fares" },
        loadChildren: () =>
          import("../main/fare-management/fare-management.module").then(
            (m) => m.FareManagementModule
          ),
      },
      {
        path: "promo",
        canActivate: [PermissionGuard],
        data: { access: "coupon" },
        loadChildren: () =>
          import("../main/promo-management/promo-management.module").then(
            (m) => m.PromoManagementModule
          ),
      },
      {
        path: "banner",
        canActivate: [PermissionGuard],
        data: { access: "banner" },
        loadChildren: () =>
          import("../main/banner-management/banner-management.module").then(
            (m) => m.BannerManagementModule
          ),
      },
      {
        path: "pickdrop",
        canActivate: [PermissionGuard],
        data: { access: "pickDropSettings" },
        loadChildren: () =>
          import("../main/pickdrop-management/pickdrop-management.module").then(
            (m) => m.PickdropManagementModule
          ),
      },
      {
        path: "menu",
        canActivate: [PermissionGuard],
        data: { access: "invoice" },
        loadChildren: () =>
          import("../main/pickdrop-management/pickdrop-management.module").then(
            (m) => m.PickdropManagementModule
          ),
      },
      // {
      //   path: "service-area",
      //   canActivate: [PermissionGuard],
      //   data: { access: "service-area" },
      //   loadChildren: () =>
      //     import("../main/service-area/service-area-management.module").then(
      //       (m) => m.ServiceManagementModule
      //     ),
      // },
      {
        path: "merchant",
        canActivate: [PermissionGuard],
        data: { access: "merchant" },
        loadChildren: () =>
          import("../main/merchant-management/merchant-management.module").then(
            (m) => m.MerchantManagementModule
          ),
      },
      {
        path: "map",
        canActivate: [PermissionGuard],
        data: { access: "map" },
        loadChildren: () =>
          import("../main/map-management/map-management.module").then(
            (m) => m.MapManagementModule
          ),
      },
      {
        path: "service-area-management",
        canActivate: [PermissionGuard],
        data: { access: "serviceArea" },
        loadChildren: () =>
          import("../main/officer/officer.module").then((m) => m.OfficerModule),
      },

      {
        path: "driver-management",
        canActivate: [PermissionGuard],
        data: { access: "drivers" },
        loadChildren: () =>
          import("../main/driver-management/driver-management.module").then(
            (m) => m.DriverManagementModule
          ),
      },
      {
        path: "reports-management",
        canActivate: [PermissionGuard],
        data: { access: "EO" },
        loadChildren: () =>
          import("../main/report-management/report-management.module").then(
            (m) => m.ReportManagementModule
          ),
      },
      {
        path: "trips-management",
        canActivate: [PermissionGuard],
        data: { access: "trips" },
        loadChildren: () =>
          import("../main/trips-management/trips-management.module").then(
            (m) => m.TripsManagementModule
          ),
      },
      {
        path: "stakeholder",
        canActivate: [PermissionGuard],
        data: { access: "stakeholders" },
        loadChildren: () =>
          import("../main/stack-holder/shareholder.module").then(
            (m) => m.ShareholderModule
          ),
      },
      {
        path: "payout",
        canActivate: [AuthGuardMain],
        data: { access: "payout" },
        loadChildren: () =>
          import("../main/payout/payout.module").then((m) => m.PayoutModule),
      },
      {
        path: "covid",
        canActivate: [PermissionGuard],
        data: { access: "covidTracker" },
        loadChildren: () =>
          import("../main/covid/covid.module").then((m) => m.CovidModule),
      },
      {
        path: "terminal-management",
        canActivate: [PermissionGuard],
        data: { access: "terminals" },
        loadChildren: () =>
          import("../main/terminal-management/terminal-management.module").then(
            (m) => m.TerminalManagementModule
          ),
      },
      {
        path: "setting",
        data: { access: "setting" },
        canActivate: [AuthGuardMain],
        loadChildren: () =>
          import("../main/setting-management/setting-management.module").then(
            (m) => m.SettingManagementModule
          ),
      },
      {
        path: "refund",
        data: { access: "refund" },
        canActivate: [AuthGuardMain],
        loadChildren: () =>
          import("../main/refund-managenent/refund-managenent.module").then(
            (m) => m.RefundManagementModule
          ),
      },
      {
        path: "transaction-history",
        canActivate: [PermissionGuard],
        data: { access: "refund" },
        loadChildren: () =>
          import("../main/transaction-history/transaction-history.module").then(
            (m) => m.TransactionHistoryModule
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule {}
